import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {createAuthHeader} from "../Axios/axiosConfig";

import Cookies from "js-cookie";
import {CURRENT_USER_ID_COOKIE, VIEW_AS_USER_ID_COOKIE} from "../Constants/constants";

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL
});

const httpLinkReports = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_REPORTS_URL
});

const authLink = setContext(async (_, {headers}) => {
    let currentUserId = Cookies.get(CURRENT_USER_ID_COOKIE);
    let viewAsUserId = Cookies.get(VIEW_AS_USER_ID_COOKIE);
    if (!viewAsUserId && currentUserId) {
        Cookies.set(VIEW_AS_USER_ID_COOKIE, Cookies.get(CURRENT_USER_ID_COOKIE));
    }
    return {
        headers: {
            ...headers,
            // 'content-type': 'application/graphql'
            'Authorization': await createAuthHeader(),
            'active_user_id': Cookies.get(VIEW_AS_USER_ID_COOKIE)
        }
    }
});

export const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all'
        }
    }
});

export const apolloClientReports = new ApolloClient({
    link: authLink.concat(httpLinkReports),
    cache: new InMemoryCache(),
    defaultOptions: {
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all'
        }
    }
});
